// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__cK9jf","error":"Notification_error__zmAcq","success":"Notification_success__MFgj0"};